import type { ReactNode } from 'react'
import React from 'react'
import { HoverContainer, HoverMenuContainer } from '../hover-menu'
import { HorizontalStack } from '@ztechapps/webui.util'

export type ContainerWithContextMenuProps = {
  children?: ReactNode
  contextMenuContent?: ReactNode
  disabled?: boolean
  as?: any
  className?: string
}
export const ContainerWithContextMenu = ({ children, contextMenuContent, disabled, as, className }: ContainerWithContextMenuProps) => {
  return (
    <HoverContainer as={as} disabled={disabled} className={className}>
      <HorizontalStack gap={3} className="align-items-start">
        <div className="">{children}</div>
        <HoverMenuContainer>{contextMenuContent}</HoverMenuContainer>
      </HorizontalStack>
    </HoverContainer>
  )
}
